import BaseCallUs from '@components/features/landing-pages/BaseCallUs';

const CallUs = () => {
  return <BaseCallUs subheader="Not ready to choose? Chat with a broker, there’s absolutely no commitment." />;
};

export default CallUs;
